import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../reducers";
import { createXDomeTheme } from "../../theme";
import { Snackbar, SnackbarCloseReason, ThemeProvider, Typography } from "@material-ui/core";
import Routes from "./Routes";
import { compose } from "redux";
import { getCurrentUser } from "../../api/user";
import { UserActionType } from "../../reducers/user.reducer";
import { Alert } from "../../components/Alert/Alert";
import { SnackbarState } from "../../domain/domain";
import ExportNodeDialog from "../../components/ExportNodeDialog/ExportNodeDialog";
import { UiActionType } from "../../reducers/ui.reducer";
import AddEditNodeDialog from "../ComponentManagementPage/AddEditNodeDialog";
import RepealNodeDialog from "../ComponentManagementPage/RepealNodeDialog";
import RemoveNodeDialog from "../ComponentManagementPage/RemoveNodeDialog";
import SessionTimeout from "../Global/SessionTimeout";

type Props = {
    authenticated: boolean,
    dispatch: (msg: any) => void,
    snackbarState: SnackbarState
}

const AppEntryPoint: React.FC<Props> = ({ authenticated, snackbarState, dispatch }) => {

    const theme = createXDomeTheme()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true);
        getCurrentUser().then(response => {
            setLoading(false);
            dispatch({ type: UserActionType.USER_LOADED, user: response.data })
        }).catch(error => {
            console.error(error);
            setLoading(false);
        })
    }, [dispatch]);

    if (loading) {
        return <></>
    }

    const closeSnackbar = () => {
        dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: false, message: snackbarState.message, severity: snackbarState.severity } });
    }

    return (
        <ThemeProvider theme={theme}>
            <Snackbar
                open={snackbarState.open}
                onClick={() => closeSnackbar()}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                style={{ transform: "translateY(60px) translateX(12px)" }}
                autoHideDuration={3000}
                onClose={(_, reason: SnackbarCloseReason) => {
                    if (reason !== "clickaway") {
                        closeSnackbar();
                    }
                }}>
                <Alert onClose={() => { closeSnackbar(); }} title={""} severity={snackbarState.severity}>
                    <Typography>{snackbarState.message}</Typography>
                </Alert>
            </Snackbar>
            <ExportNodeDialog />
            <AddEditNodeDialog />
            <RepealNodeDialog />
            {/* <RejectAllDialog /> */}
            <RemoveNodeDialog />
            <Routes authenticated={authenticated} />
            <SessionTimeout authenticated={authenticated} />
        </ThemeProvider>
    );

};

const mapStateToProps = (state: ApplicationState) => {
    return {
        authenticated: state.user.currentUser !== undefined,
        snackbarState: state.ui.snackbarState
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return { dispatch };
}

export default compose<any>(
    connect(mapStateToProps, mapDispatchToProps)
)(AppEntryPoint);

